'use strict'; // Load modules

var _classCallCheck = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Any = require('../any');

var Hoek = require('hoek'); // Declare internals


var internals = {
  Set: require('../../set')
};

internals.Boolean =
/*#__PURE__*/
function (_Any) {
  _inherits(_class, _Any);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
    _this._type = 'boolean';
    _this._flags.insensitive = true;
    _this._inner.truthySet = new internals.Set();
    _this._inner.falsySet = new internals.Set();
    return _this;
  }

  _createClass(_class, [{
    key: "_base",
    value: function _base(value, state, options) {
      var result = {
        value: value
      };

      if (typeof value === 'string' && options.convert) {
        var normalized = this._flags.insensitive ? value.toLowerCase() : value;
        result.value = normalized === 'true' ? true : normalized === 'false' ? false : value;
      }

      if (typeof result.value !== 'boolean') {
        result.value = this._inner.truthySet.has(value, null, null, this._flags.insensitive) ? true : this._inner.falsySet.has(value, null, null, this._flags.insensitive) ? false : value;
      }

      result.errors = typeof result.value === 'boolean' ? null : this.createError('boolean.base', null, state, options);
      return result;
    }
  }, {
    key: "truthy",
    value: function truthy() {
      var obj = this.clone();
      var values = Hoek.flatten(Array.prototype.slice.call(arguments));

      for (var i = 0; i < values.length; ++i) {
        var value = values[i];
        Hoek.assert(value !== undefined, 'Cannot call truthy with undefined');

        obj._inner.truthySet.add(value);
      }

      return obj;
    }
  }, {
    key: "falsy",
    value: function falsy() {
      var obj = this.clone();
      var values = Hoek.flatten(Array.prototype.slice.call(arguments));

      for (var i = 0; i < values.length; ++i) {
        var value = values[i];
        Hoek.assert(value !== undefined, 'Cannot call falsy with undefined');

        obj._inner.falsySet.add(value);
      }

      return obj;
    }
  }, {
    key: "insensitive",
    value: function insensitive(enabled) {
      var insensitive = enabled === undefined ? true : !!enabled;

      if (this._flags.insensitive === insensitive) {
        return this;
      }

      var obj = this.clone();
      obj._flags.insensitive = insensitive;
      return obj;
    }
  }, {
    key: "describe",
    value: function describe() {
      var description = Any.prototype.describe.call(this);
      description.truthy = [true].concat(this._inner.truthySet.values());
      description.falsy = [false].concat(this._inner.falsySet.values());
      return description;
    }
  }]);

  return _class;
}(Any);

module.exports = new internals.Boolean();